import React from "react";
import { Tabs } from "antd";
const { TabPane } = Tabs;

const WorkTab = () => {
  return (
    <div>
      <Tabs data-aos="fade-up" defaultActiveKey="1" className="pt-1" centered>
        <TabPane tab="App Development & Management">
          <div className="d-flex justify-content-center tab-content">
            <a
              href="/service/custom-app-development"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Custom App Development</p>
            </a>
            <a
              href="/service/web-app-development"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Web App Development</p>
            </a>
            <a
              href="/service/mobile-app-development"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Mobile App Development</p>
            </a>
            <a
              href="/service/app-maintenance-services"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                App <br /> Maintenance
              </p>
            </a>
            <a
              href="/service/app-modernization"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                App <br /> Modernization
              </p>
            </a>
            <a
              href="/service/cross-platform-app-development"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Cross Platform App Development</p>
            </a>
          </div>
        </TabPane>
        <TabPane tab="Digital Services" key="2">
          <div className="d-flex justify-content-center tab-content">
            <a
              href="/service/it-consulting-and-strategy"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">IT Strategy & Consulting</p>
            </a>
            <a
              href="/service/digital-transformation"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Digital Transformation</p>
            </a>
            <a
              href="/service/software-product-development"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Software Product Development</p>
            </a>
            <a
              href="/service/dedicated-teams"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                Dedicated <br /> Teams
              </p>
            </a>
            <a
              href="/service/it-staff-augmentation"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                IT Staff <br /> Augmentation
              </p>
            </a>
            <a
              href="/service/quality-assurance"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                Quality <br /> Assurance
              </p>
            </a>
          </div>
        </TabPane>
        <TabPane tab="Latest Technology" key="3">
          <div className="d-flex justify-content-center tab-content">
            <a
              href="/service/ai-and-machine-learning"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                AI & Machine <br /> Learning
              </p>
            </a>
            <a
              href="/service/internet-of-things"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">IOT</p>
            </a>
            <a
              href="/service/blockchain"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Blockchain</p>
            </a>
            <a
              href="/service/augmented-and-virtual-reality"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">AR/VR</p>
            </a>
            <a
              href="/service/cybersecurity"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Cybersecurity</p>
            </a>
          </div>
        </TabPane>
        <TabPane tab="Data & Analytics" key="4">
          <div className="d-flex justify-content-center tab-content">
            <a
              href="/service/business-intelligence-consulting"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">BI Consulting</p>
            </a>
            <a
              href="/service/business-intelligence-testing"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">BI Testing</p>
            </a>
            <a
              href="/service/business-intelligence-integration"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">BI Integration</p>
            </a>
          </div>
        </TabPane>
        <TabPane tab="Cloud & DevOps" key="5">
          <div className="d-flex justify-content-center tab-content">
            <a
              href="/service/aws-cloud"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">AWS Cloud</p>
            </a>
            <a
              href="/service/azure-cloud"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Azure Cloud</p>
            </a>
            <a
              href="/service/google-cloud"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Google Cloud</p>
            </a>
          </div>
        </TabPane>
      </Tabs>
      <div data-aos="fade-up" className="pt-1 tab-sm">
        <div className="mt-2">
          <h3 className="mb-25 text-center">App Development & Management</h3>
          <div className="d-flex justify-content-center tab-content">
            <a className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Custom App Development</p>
            </a>
            <a
              href="/service/web-app-development"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Web App Development</p>
            </a>
            <a
              href="/service/mobile-app-development"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Mobile App Development</p>
            </a>
            <a
              href="/service/app-maintenance-services"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                App <br /> Maintenance
              </p>
            </a>
            <a
              href="/service/app-modernization"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                App <br /> Modernization
              </p>
            </a>
            <a
              href="/service/cross-platform-app-development"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Cross Platform App Development</p>
            </a>
          </div>
        </div>
        <div className="mt-2">
          <h3 className="mb-25 text-center">Digital Services</h3>
          <div className="d-flex justify-content-center tab-content">
            <a
              href="/service/it-consulting-and-strategy"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">IT Strategy & Consulting</p>
            </a>
            <a
              href="/service/digital-transformation"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Digital Transformation</p>
            </a>
            <a
              href="/service/software-product-development"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Software Product Development</p>
            </a>
            <a
              href="/service/dedicated-teams"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                Dedicated <br /> Teams
              </p>
            </a>
            <a
              href="/service/it-staff-augmentation"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                IT Staff <br /> Augmentation
              </p>
            </a>
            <a
              href="/service/quality-assurance"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                Quality <br /> Assurance
              </p>
            </a>
          </div>
        </div>
        <div className="mt-2">
          <h3 className="mb-25 text-center">Latest Technology</h3>
          <div className="d-flex justify-content-center tab-content">
            <a
              href="/service/ai-and-machine-learning"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">
                AI & Machine <br /> Learning
              </p>
            </a>
            <a
              href="/service/internet-of-things"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">IOT</p>
            </a>
            <a
              href="/service/blockchain"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Blockchain</p>
            </a>
            <a
              href="/service/augmented-and-virtual-reality"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">AR/VR</p>
            </a>
            <a
              href="/service/cybersecurity"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Cybersecurity</p>
            </a>
          </div>
        </div>
        <div className="mt-2">
          <h3 className="mb-25 text-center">Data & Analytics</h3>
          <div className="d-flex justify-content-center tab-content">
            <a
              href="/service/business-integration-consulting"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">BI Consulting</p>
            </a>
            <a
              href="/service/business-intelligence-testing"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">BI Testing</p>
            </a>
            <a
              href="/service/business-intelligence-integration"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">BI Integration</p>
            </a>
          </div>
        </div>
        <div className="mt-2">
          <h3 className="mb-25 text-center">Cloud & DevOps</h3>
          <div className="d-flex justify-content-center tab-content">
            <a
              href="/service/aws-cloud"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">AWS Cloud</p>
            </a>
            <a
              href="/service/azure-cloud"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Azure Cloud</p>
            </a>
            <a
              href="/service/google-cloud"
              className="d-flex flex-column justify-content-center align-items-center text-black tabbox text-center m-50">
              <i className="fas fa-mobile-alt mb-1"></i>
              <p className="m-0 font-sm">Google Cloud</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkTab;
